export const apiKeyGMap = 'AIzaSyDBOPhk-_Qrj8BH5yGgI3tnuvhZtFSRi1o';

// Fallback center if no coords are provided
export const defaultCoords = {
  lat: 40.748817,
  lng: -73.985428,
};

export const geocodeAddress = (address: string): Promise<{ lat: number; lng: number } | null> => {
  return new Promise((resolve, reject) => {
    if (!window.google?.maps?.Geocoder) {
      return reject('Google Maps Geocoder not available.');
    }

    const geocoder = new window.google.maps.Geocoder();
    geocoder.geocode({ address }, (results, status) => {
      if (status === 'OK' && results && results[0]?.geometry?.location) {
        const location = results[0].geometry.location;
        resolve({ lat: location.lat(), lng: location.lng() });
      } else {
        console.error('Geocode error:', status);
        resolve(null);
      }
    });
  });
};
